import { render, staticRenderFns } from "./TopCard.vue?vue&type=template&id=3276766a&scoped=true&"
import script from "./TopCard.vue?vue&type=script&lang=ts&"
export * from "./TopCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3276766a",
  null
  
)

export default component.exports